import React from "react";
import { Navigate } from "react-router-dom";
import { getDefaultDashboardRoute, isMasterAdmin } from "../utils/permissions";

const MasterAdminRoute = ({ children }) => {
  if (!isMasterAdmin()) {
    return <Navigate to={getDefaultDashboardRoute()} replace />;
  }
  return children;
};

export default MasterAdminRoute;
